<template>
  <v-card flat>
    <v-toolbar color="green lighten-1" dark extended flat>
      <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
    </v-toolbar>

    <v-layout row pb-2>
      <v-flex xs8 offset-xs2>
        <v-card class="card--flex-toolbar">
          <form @submit="search">
            <v-toolbar card prominent>
              <v-toolbar-title class="body-2 grey--text">
                <v-text-field
                  hide-details
                  label="Search"
                  v-model="searchValue"
                ></v-text-field>
              </v-toolbar-title>

              <v-spacer></v-spacer>
              <v-btn type="submit" icon> <v-icon>search</v-icon> </v-btn>
            </v-toolbar>
          </form>

          <v-divider></v-divider>

          <v-card-text>
            <v-list two-line>
              <template v-for="(item, index) in playlists">
                <v-list-tile :key="item.id" avatar ripple>
                  <v-list-tile-avatar :v-if="item.images[0]">
                    <img :src="item.images[0].url" />
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                    <v-list-tile-sub-title class="text--primary"
                      >{{ item.tracks.total }} tracks</v-list-tile-sub-title
                    >
                    <!-- <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title> -->
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <!-- <v-list-tile-action-text>{{ item.popularity }}</v-list-tile-action-text> -->
                    <v-btn icon :to="`/play/${item.id}`">
                      <v-icon>play_arrow</v-icon>
                    </v-btn>
                    <!-- <v-icon v-else color="yellow darken-2">star</v-icon> -->
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider
                  v-if="index + 1 < playlists.length"
                  :key="index"
                ></v-divider>
              </template>
            </v-list>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      searchValue: ""
    };
  },
  methods: {
    play: function() {
      this.$store.dispatch("play");
    },
    search: function(e) {
      const { searchValue } = this;
      e.preventDefault();

      this.$store.dispatch("searchPlaylist", searchValue);
    }
  },
  computed: {
    playlists() {
      return this.$store.getters.playlists.items;
    }
  }
};
</script>
<style>
.card--flex-toolbar {
  margin-top: -64px;
}
</style>
